import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function LeftBarLoadingSkeleton() {
    return (
        <React.Fragment>
            <div style={{ marginBottom: 15 }}>
                <Skeleton count={1} height={15} width={"60%"} />
            </div>
            <div style={{ marginBottom: 15 }}>
                <Skeleton count={1} height={15} width={"40%"} />
            </div>
            <div style={{ marginBottom: 15 }}>
                <Skeleton count={1} height={15} width={"50%"} />
            </div>
        </React.Fragment>
    )
}

export default memo(LeftBarLoadingSkeleton)